import React, { useState } from 'react';
import { Tabs } from 'tdesign-react';
import styled from 'styled-components';
import { find } from 'lodash';
import ListPanel from '@/components/ListPanel';
import ShadowCard from '@/components/ShadowCard';
import { scopeTypeOptions } from '@/utils/constant';
import { doBuried } from '@/services/buriedService';
import Template from './Template';
import Group from './Group';
import VariableTable from './VariableTable';

export default function Variables() {
  const [currentTab, setCurrentTab] = useState(0);
  const [group, setGroup] = useState();

  const onChange = (value) => {
    setCurrentTab(value);
    const { eventId } = find(scopeTypeOptions, { value });
    doBuried({ eventId });
  };

  return (
    <>
      <ListPanel header='变量管理'>
        <Tabs value={currentTab} onChange={onChange}>
          {scopeTypeOptions.map((item) => (
            <Tabs.TabPanel key={item.value} value={item.value} destroyOnHide label={item.label} />
          ))}
        </Tabs>
        <Template scopeType={currentTab} />
      </ListPanel>
      <Body>
        <Group group={group} scopeType={currentTab} onSelect={setGroup} />
        <VariableTable group={group} scopeType={currentTab} />
      </Body>
    </>
  );
}

const Body = styled(ShadowCard)`
  margin-top: 16px;
  margin-right: 20px;
  .shadow-card-body {
    padding: 0;
    display: flex;
  }
`;
